import { render } from "./honoreeVotingBanner.vue?vue&type=template&id=a9468e12"
import script from "./honoreeVotingBanner.vue?vue&type=script&lang=js"
export * from "./honoreeVotingBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__